<template>
  <div class="circle-charts" ref="chartdiv"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  props: {
    geneData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.initCircle();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initCircle() {
      let chart = am4core.create(
        this.$refs.chartdiv,
        am4plugins_forceDirected.ForceDirectedTree
      );
      let networkSeries = chart.series.push(
        new am4plugins_forceDirected.ForceDirectedSeries()
      );
      networkSeries.data = this.geneData;
      networkSeries.useGeodata = true;
      networkSeries.dataFields.linkWith = "linkWith";
      networkSeries.dataFields.name = "name";
      networkSeries.dataFields.id = "name";
      networkSeries.dataFields.value = "value";
      networkSeries.dataFields.children = "children";
      networkSeries.dataFields.color = "color";
      networkSeries.links.template.distance = 1;

      networkSeries.nodes.template.tooltipText = "{name}（{value}）";
      networkSeries.nodes.template.fillOpacity = 1;
      networkSeries.nodes.template.outerCircle.scale = 1;
      networkSeries.nodes.template.togglable = false;
      networkSeries.nodes.template.label.text = "{value}\n{name}";
      let fillModifier = new am4core.LinearGradientModifier();
      // fillModifier.opacities  = [0,1];
      fillModifier.brightnesses = [-0.2, 1];
      fillModifier.offsets = [0.2, 1];
      fillModifier.gradient.rotation = -90;
      networkSeries.nodes.template.fillModifier = fillModifier;
      networkSeries.nodes.template.expandDistance = -0.2;

      networkSeries.fontSize = 10;
      networkSeries.nodes.template.label.hideOversized = true;
      networkSeries.nodes.template.label.truncate = true;
      networkSeries.minRadius = am4core.percent(2);
      networkSeries.manyBodyStrength = -5;
      networkSeries.links.template.strokeOpacity = 0;

      let eles = document.querySelectorAll("[aria-labelledby$=-title]");
      eles.forEach((ele) => {
        ele.style.visibility = "hidden";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 0) {
  .circle-charts {
    width: 100%;
    height: 550px;
  }
}
@media only screen and (min-width: 1580px) {
  .circle-charts {
    width: 100%;
    height: 700px;
  }
}
</style>